<template>
    <div id="search">
        <div class="row">
            <div class="col-12 col-md-3 mb-3 position-relative">
                <div id="filters">
                    <h2 class="h5 mb-3">{{t.product.filter_search}}</h2>
                    <div class="btn btn-sm btn-outline-dark mb-3"
                        @click="resetFilters"
                        v-show="search
                        || in_stock
                        // || priceRange[0] > 0
                        // || priceRange[1] < maxPrice
                        || priceRange[0] != null
                        || priceRange[1] != null
                        || selectedCategories.length
                        || selectedBrands.length
                        || selectedFilters.length
                        || rating
                        || booleanFilters.length
                        || _.find(ranges, function (range) { return range[0] || range[1]})">
                        <i class="fas fa-ban fa-fw"></i> {{t.product.reset_filters}}
                    </div>
                    <div class="input-group mb-3">
                        <input v-model="search" type="text" class="form-control" v-on:keypress.enter="filterResult"
                        v-on:keyup.delete="search == '' ? filterResult() : null" :disabled="!loaded">
                        <div class="input-group-append">
                            <button class="btn btn-primary rounded-start-0" type="button" @click="filterResult" :disabled="!loaded"><i class="fas fa-search"></i></button>
                        </div>
                    </div>
                    <div v-if="showPrice" class="mb-3">
                        <label>{{t.product.price}}</label>
                        <div class="d-flex">
                            <div class="input-group input-group-sm me-3 ms-auto">
                                <input type="number" :placeholder="t.global.min"
                                v-model.number="priceRange[0]" @change="filterResult" :disabled="!loaded" min="0" class="form-control border-end-0">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-white border-start-0 rounded-start-0">{{currency.symbol}}</span>
                                </div>
                            </div>
                            <div class="input-group input-group-sm ms-auto">
                                <input type="number" :placeholder="t.global.max"
                                v-model.number="priceRange[1]" @change="filterResult" :disabled="!loaded" min="0" class="form-control border-end-0">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-white border-start-0 rounded-start-0">{{currency.symbol}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="config.modules.reviews" class="mb-3">
                        <label>{{t.reviews.rating}}</label>
                        <select v-model="rating" class="form-select w-auto" @change="filterResult" :disabled="!loaded">
                            <option :value="null">{{t.global.all}}</option>
                            <option v-for="i in config.reviews.rate_max_value" :key="i" :value="i">{{i}} <i class="fa-solid fa-star fa-sm"></i></option>
                        </select>
                    </div>
                    <div v-if="config.modules.stock" class="mb-3 checkbox-group">
                        <input id="in_stock" type="checkbox" class="me-1" @change="filterResult" v-model="in_stock" :disabled="!loaded" />
                        <label for="in_stock">
                            {{t.product.in_stock}}
                            <!-- <span v-if="loaded && !in_stock" class="ms-2 badge rounded-pill bg-dark">{{nbrInStock}}</span> -->
                        </label>
                    </div>
                    <div v-if="categories && categories.length">
                        <label>{{ pageType == 'category' ? t.product.subcategories : t.product.categories}}</label>
                        <div v-for="category in categories" :key="category.slug" class="ms-3 checkbox-group">
                            <input :id="category.slug" type="checkbox" class="me-1"
                            v-model="selectedCategories"
                            :value="category.slug"
                            @change="filterResult"
                            :disabled="!loaded">
                            <label :for="category.slug">
                                {{category.name}} <span v-if="!selectedCategories.find((slug) => slug == category.slug) && loaded" class="ms-2 badge rounded-pill bg-dark">{{category.count}}</span>
                            </label>
                            <div v-for="subcategory in category.subcategories_has_products" v-bind:key="subcategory.id"class="ms-3 checkbox-group" >
                                <input :id="subcategory.slug" type="checkbox" class="me-1"
                                v-model="selectedCategories"
                                :value="subcategory.slug"
                                @change="filterResult"
                                :disabled="!loaded">
                                <label :for="subcategory.slug">
                                    {{subcategory.name}} <span v-if="!selectedCategories.find((slug) => slug == subcategory.slug) && loaded" class="ms-2 badge rounded-pill bg-dark">{{subcategory.count}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-if="brands && brands.length">
                        <label>{{t.product.brands}}</label>
                        <div v-for="brand in brands" :key="brand.slug" class="ms-3 checkbox-group">
                            <input :id="brand.slug" type="checkbox" class="me-1"
                            v-model="selectedBrands"
                            :value="brand.slug"
                            @change="filterResult"
                            :disabled="!loaded">
                            <label :for="brand.slug">
                                {{brand.name}} <span v-if="!selectedBrands.find((slug) => slug == brand.slug) && loaded" class="ms-2 badge rounded-pill bg-dark">{{brand.count}}</span>
                            </label>
                        </div>
                    </div>
                    <div v-if="filters && filters.length" class="mt-3">
                        <div class="mb-2" v-for="filter in filters" :key="filter.slug">
                            <!-- <div v-if="filter.type != 'boolean'" class="fw-bold mb-3">{{filter.name}}</div> -->
                            <div class="fw-bold mb-3">{{filter.name}}</div>
                            <div v-if="filter.type == 'numeric'" class="d-flex">
                                <div class="input-group input-group-sm me-3 ms-auto">
                                    <input type="number" :placeholder="t.global.min"
                                    v-model.number="ranges[filter.slug][0]" @change="filterResult" :disabled="!loaded" min="0" class="form-control">
                                    <div v-if="filter.unitName" class="input-group-append">
                                        <span class="input-group-text">{{filter.unitName}}</span>
                                    </div>
                                </div>
                                <div class="input-group input-group-sm ms-auto">
                                    <input type="number" :placeholder="t.global.max"
                                    v-model.number="ranges[filter.slug][1]" @change="filterResult" :disabled="!loaded" min="0" class="form-control">
                                    <div v-if="filter.unitName" class="input-group-append">
                                        <span class="input-group-text">{{filter.unitName}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="filter.type == 'boolean'">
                                <input type="checkbox"
                                    :id="filter.slug"
                                    v-model="booleanFilters"
                                    :value="filter.slug"
                                    @change="filterResult"
                                    :disabled="!loaded"
                                    class="ms-3 checkbox-group"> <label :for="filter.slug">{{filter.name}}</label>
                                    <span class="badge ml-2" v-if="!booleanFilters.find((slug) => slug == filter.slug) && loaded">{{filter.count}}</span>
                            </div>
                            <div v-else-if="filter.type == 'multi'">
                                <div v-for="value in filter.possible_values" :key="value.slug" class="ms-3 checkbox-group">
                                    <input :id="filter.slug+'_'+value.slug" type="checkbox" class="me-1"
                                    v-model="selectedFilters"
                                    :value="filter.slug+'_'+value.slug"
                                    @change="filterResult"
                                    :disabled="!loaded"><label :for="filter.slug+'_'+value.slug">
                                        {{value.name}} <span v-if="filter.unitName">{{filter.unitName}}</span> <span v-if="!selectedFilters.find((index) => index == filter.slug+'_'+value.slug) && loaded" class="ms-2 badge rounded-pill bg-dark">{{value.count}}</span></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div v-if="loaded && products.length" id="shop" class="shop">
                    <div v-if="loaded" class="fst-italic mb-2">
                        <b>{{ result.total }}</b> {{t.product.products}}
                    </div>
                    <div class="row">
                        <div v-for="product in products" :key="product.id" class="product col-sm-6 col-12">
                            <product-block-component :data-product="product"></product-block-component>
                        </div>
                    </div>
                    <Bootstrap5Pagination
                        :data="result"
                        @pagination-change-page="getResult"
                    />
                </div>
                <div v-else-if="!loaded" class="d-flex justify-content-center align-items-center fst-italic" style="min-height:300px">
                    <div class="spinner-grow text-muted" role="status">
                       <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
                <div v-else class="fst-italic">
                    {{t.product.no_products}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from '../CartStore';

import Bootstrap5Pagination from 'laravel-vue-pagination';
export default {
    components: {
        Bootstrap5Pagination
    },
    store: store,
    data() {
        return {
            t: t,
            config: config,
            currency: window.currency,
            pageType: window.page_type,
            selectedCategories: window.params.categories
                ? window.params.categories
                : [],
            selectedBrands: window.params.brands
                ? window.params.brands
                : [],
            selectedFilters: window.params.filters
                ? window.params.filters
                : [],
            booleanFilters: window.params.b_filters
                ? window.params.b_filters
                : [],
            ranges: window.ranges,
            categories: [],
            brands: [],
            category: window.category,
            priceRange: window.params.price_range
                ? window.params.price_range
                : [null, null],
            // maxPrice: window.maxPrice,
            rating: window.params.rating ? window.params.rating : null,
            search: window.params.search,
            in_stock: window.params.in_stock,
            result: {},
            // nbrInStock: null,
            products: [],
            filters: [],
            // page: 1,
            tooltipFormatter: this.amountWithCurrency('{value}', false),
            // infiniteId: new Date(),
            loaded: false,
            showPrice: config.modules.catalog_mode === false,
        };
    },
    mounted() {
        this.getResult(window.params.page ? window.params.page : 1)
    },
    methods: {
        ...Vuex.mapActions(["addProduct"]),
        addToCart(product) {
            product.qty = 1
            this.addProduct(product)
        },
        resetFilters() {
            // this.page = 1;
            this.result.current_page = 1
            this.search = null
            this.rating = null
            this.in_stock = null
            // this.priceRange = [0, window.maxPrice]
            this.priceRange = [null, null]
            this.selectedCategories = []
            this.selectedBrands = []
            this.selectedFilters = []
            this.booleanFilters = []
            $.each(this.ranges, (index, range) => { this.ranges[index] = [null, null] })
            this.products = []
            if($('#search').length) {
                $('html').animate({ scrollTop: $('#search').offset().top - 150 }, 100)
            }
            this.getResult()
            // this.infiniteId += 1
        },
        filterResult() {
            // this.page = 1;
            this.products = []
            if($('#search').length) {
                $('html').animate({ scrollTop: $('#search').offset().top - 150 }, 100)
            }
            this.getResult(1)
            // this.infiniteId += 1
        },
        getResult (page = 1) {
        // ($state) {
            this.loaded = false
            axios
            .post("/ajax/search", {
                // page: this.page,
                page: page,
                category: this.category ? this.category.slug : null,
                categories: this.selectedCategories,
                brands: this.selectedBrands,
                filters: this.selectedFilters,
                b_filters: this.booleanFilters,
                ranges: this.ranges,
                search: this.search,
                rating: this.rating,
                price_range: this.priceRange,
                in_stock: this.in_stock,
            })
            .then((response) => {
                this.result = response.data.products;
                if (this.result.current_page == 1) {
                    this.filters = response.data.filters;
                    this.categories = response.data.categories;
                    this.brands = response.data.brands;
                    // this.nbrInStock = response.data.in_stock;
                }
                if (this.result.data.length) {
                    // this.updatePageInUrl()
                    // this.page += 1;
                    // this.products.push(...this.result.data);
                    this.products = this.result.data;
                    // $state.loaded();
                } else {
                    // $state.complete();
                }
                this.changeUrl()
                this.loaded = true
            });
        },
        changeUrl() {
            var url = this.url('products')
            if (this.category) {
                url += '/'+this.category.slug
            }
            var stringQueries = []
            if (this.selectedCategories.length) {
                stringQueries.push('categories='+this.selectedCategories.map(categorySlug => `${categorySlug}`).join(','))
            }
            if (this.selectedBrands.length) {
                stringQueries.push('brands='+this.selectedBrands.map(brandSlug => `${brandSlug}`).join(','))
            }
            if (this.booleanFilters.length) {
                stringQueries.push('b_filters='+this.booleanFilters.map(filterSlug => `${filterSlug}`).join(','))
            }
            if (this.selectedFilters.length) {
                var filtersQueryString = {}
                $.each(this.selectedFilters, function(key, values) {
                    var aValues = values.split('_')
                    var attrSlug = aValues[0]
                    var valueSlug = aValues[1]
                    if (filtersQueryString[attrSlug]) {
                        filtersQueryString[attrSlug].push(valueSlug)
                    } else {
                        filtersQueryString[attrSlug] = [valueSlug]
                    }
                })
                $.each(filtersQueryString, function(filterSlug, values) {
                    stringQueries.push('filters['+filterSlug+']='+values.join(','))
                })
            }
            // if (this.priceRange && (this.priceRange[0] != '0' || this.priceRange[1] != this.maxPrice.toString())) {
            //     stringQueries.push(this.priceRange.map(value => `price_range[]=${value}`).join('&'))
            // }
            if (this.priceRange && (this.priceRange[0] !== null || this.priceRange[1] !== null)) {
                stringQueries.push(this.priceRange.map(value => `price_range[]=${value}`).join('&'))
            }
            if (Object.keys(this.ranges).length) {
                $.each(this.ranges, function(attributeSlug, value) {
                    if (value[0] || value[1])
                    stringQueries.push(`ranges[${attributeSlug}]=${value[0]},${value[1]}`)
                })
            }
            if (this.rating) {
                stringQueries.push('rating='+this.rating)
            }
            if (this.in_stock) {
                stringQueries.push('in_stock='+(this.in_stock ? 1 : 0))
            }
            if (this.search) {
                stringQueries.push('search='+this.search)
            }
            if (this.result.current_page > 1) {
                stringQueries.push('page='+this.result.current_page)
            }
            history.replaceState(
                {},
                null,
                url+(stringQueries.length ? '?'+stringQueries.join('&') : '')
            )
        }
    },
};
</script>
